"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ennismore API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: daniele.befera@ennismore.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperaLiveSupportApi = exports.OperaLiveSupportApiFactory = exports.OperaLiveSupportApiFp = exports.OperaLiveSupportApiAxiosParamCreator = exports.BookingServiceApi = exports.BookingServiceApiFactory = exports.BookingServiceApiFp = exports.BookingServiceApiAxiosParamCreator = exports.AdyenApi = exports.AdyenApiFactory = exports.AdyenApiFp = exports.AdyenApiAxiosParamCreator = exports.V1YesNo = exports.V1UsaState = exports.V1TaxType = exports.V1RateCodeType = exports.V1Guest = exports.V1DayTimePart = exports.V1Country = exports.V1CotOrBed = exports.V1BookingStatus = exports.ProfileTitle = exports.LocaleLang = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.LocaleLang = {
    None: 'NONE',
    En: 'EN',
    It: 'IT',
    Es: 'ES',
    Fr: 'FR',
    Da: 'DA',
    De: 'DE'
};
/**
 * Title are per brand - in the future we should have a package called \"brand\" and store there everything that can not be shared.
 * @export
 * @enum {string}
 */
exports.ProfileTitle = {
    TitleNotSet: 'TITLE_NOT_SET',
    Mrs: 'MRS',
    Miss: 'MISS',
    Mr: 'MR',
    MrMrs: 'MR_MRS',
    Ms: 'MS',
    Dr: 'DR',
    DrMr: 'DR_MR',
    DrMrs: 'DR_MRS',
    Lord: 'LORD',
    Lady: 'LADY',
    Sheikh: 'SHEIKH',
    Sir: 'SIR',
    Captain: 'CAPTAIN',
    Professor: 'PROFESSOR',
    Mx: 'MX'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1BookingStatus = {
    None: 'NONE',
    Created: 'CREATED',
    Confirmed: 'CONFIRMED',
    Expired: 'EXPIRED',
    Cancelled: 'CANCELLED',
    PaymentError: 'PAYMENT_ERROR',
    Amended: 'AMENDED',
    PaymentReceived: 'PAYMENT_RECEIVED',
    Uncancellable: 'UNCANCELLABLE',
    CancelReceived: 'CANCEL_RECEIVED',
    CancelledByUser: 'CANCELLED_BY_USER',
    CancelledByPms: 'CANCELLED_BY_PMS',
    Completed: 'COMPLETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1CotOrBed = {
    CotBedNotSet: 'COT_BED_NOT_SET',
    Cot: 'COT',
    Bed: 'BED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1Country = {
    CountryNotSet: 'COUNTRY_NOT_SET',
    Af: 'AF',
    Al: 'AL',
    Dz: 'DZ',
    As: 'AS',
    Ad: 'AD',
    Ao: 'AO',
    Ai: 'AI',
    Aq: 'AQ',
    Ag: 'AG',
    Ar: 'AR',
    Am: 'AM',
    Aw: 'AW',
    Au: 'AU',
    At: 'AT',
    Az: 'AZ',
    Bs: 'BS',
    Bh: 'BH',
    Bd: 'BD',
    Bb: 'BB',
    By: 'BY',
    Be: 'BE',
    Bz: 'BZ',
    Bj: 'BJ',
    Bm: 'BM',
    Bt: 'BT',
    Bo: 'BO',
    Bq: 'BQ',
    Ba: 'BA',
    Bw: 'BW',
    Bv: 'BV',
    Br: 'BR',
    Io: 'IO',
    Bn: 'BN',
    Bg: 'BG',
    Bf: 'BF',
    Bi: 'BI',
    Kh: 'KH',
    Cm: 'CM',
    Ca: 'CA',
    Cv: 'CV',
    Ky: 'KY',
    Cf: 'CF',
    Td: 'TD',
    Cl: 'CL',
    Cn: 'CN',
    Cx: 'CX',
    Cc: 'CC',
    Co: 'CO',
    Km: 'KM',
    Cg: 'CG',
    Cd: 'CD',
    Ck: 'CK',
    Cr: 'CR',
    Ci: 'CI',
    Hr: 'HR',
    Cu: 'CU',
    Cw: 'CW',
    Cy: 'CY',
    Cz: 'CZ',
    Dk: 'DK',
    Dj: 'DJ',
    Dm: 'DM',
    Do: 'DO',
    Tp: 'TP',
    Ec: 'EC',
    Eg: 'EG',
    Sv: 'SV',
    Gq: 'GQ',
    Er: 'ER',
    Ee: 'EE',
    Et: 'ET',
    Fk: 'FK',
    Fo: 'FO',
    Fj: 'FJ',
    Fi: 'FI',
    Fr: 'FR',
    Fx: 'FX',
    Gf: 'GF',
    Pf: 'PF',
    Tf: 'TF',
    Ga: 'GA',
    Gm: 'GM',
    Ge: 'GE',
    De: 'DE',
    Gh: 'GH',
    Gi: 'GI',
    Gb: 'GB',
    Gr: 'GR',
    Gl: 'GL',
    Gd: 'GD',
    Gp: 'GP',
    Gu: 'GU',
    Gt: 'GT',
    Gn: 'GN',
    Gw: 'GW',
    Gy: 'GY',
    Ht: 'HT',
    Hm: 'HM',
    Hn: 'HN',
    Hk: 'HK',
    Hu: 'HU',
    Is: 'IS',
    In: 'IN',
    Id: 'ID',
    Ir: 'IR',
    Iq: 'IQ',
    Ie: 'IE',
    Im: 'IM',
    Il: 'IL',
    It: 'IT',
    Jm: 'JM',
    Jp: 'JP',
    Jo: 'JO',
    Kz: 'KZ',
    Ke: 'KE',
    Ki: 'KI',
    Kr: 'KR',
    Kp: 'KP',
    Kw: 'KW',
    Kg: 'KG',
    La: 'LA',
    Lv: 'LV',
    Lb: 'LB',
    Ls: 'LS',
    Lr: 'LR',
    Ly: 'LY',
    Li: 'LI',
    Lt: 'LT',
    Lu: 'LU',
    Mo: 'MO',
    Mk: 'MK',
    Mg: 'MG',
    Mw: 'MW',
    My: 'MY',
    Mv: 'MV',
    Ml: 'ML',
    Mt: 'MT',
    Mh: 'MH',
    Mq: 'MQ',
    Mr: 'MR',
    Mu: 'MU',
    Yt: 'YT',
    Mx: 'MX',
    Fm: 'FM',
    Mi: 'MI',
    Md: 'MD',
    Mc: 'MC',
    Mn: 'MN',
    Me: 'ME',
    Ms: 'MS',
    Ma: 'MA',
    Mz: 'MZ',
    Mm: 'MM',
    Na: 'NA',
    Nr: 'NR',
    Np: 'NP',
    Nl: 'NL',
    An: 'AN',
    Nc: 'NC',
    Nz: 'NZ',
    Ni: 'NI',
    Ne: 'NE',
    Ng: 'NG',
    Nu: 'NU',
    Nf: 'NF',
    Mp: 'MP',
    No: 'NO',
    Om: 'OM',
    Pk: 'PK',
    Pw: 'PW',
    Pa: 'PA',
    Pg: 'PG',
    Py: 'PY',
    Pe: 'PE',
    Ph: 'PH',
    Pn: 'PN',
    Pl: 'PL',
    Pt: 'PT',
    Pr: 'PR',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Ru: 'RU',
    Rq: 'RQ',
    Rw: 'RW',
    Sh: 'SH',
    Kn: 'KN',
    Lc: 'LC',
    Pm: 'PM',
    Vc: 'VC',
    Ws: 'WS',
    Sm: 'SM',
    St: 'ST',
    Sa: 'SA',
    Sn: 'SN',
    Rs: 'RS',
    Sc: 'SC',
    Sl: 'SL',
    Sg: 'SG',
    Sx: 'SX',
    Sk: 'SK',
    Si: 'SI',
    Sb: 'SB',
    So: 'SO',
    Za: 'ZA',
    Gs: 'GS',
    Ss: 'SS',
    Es: 'ES',
    Lk: 'LK',
    Sd: 'SD',
    Sr: 'SR',
    Sj: 'SJ',
    Sz: 'SZ',
    Se: 'SE',
    Ch: 'CH',
    Sy: 'SY',
    Tw: 'TW',
    Tj: 'TJ',
    Tz: 'TZ',
    Th: 'TH',
    Tg: 'TG',
    Tk: 'TK',
    To: 'TO',
    Tt: 'TT',
    Tn: 'TN',
    Tr: 'TR',
    Tm: 'TM',
    Tc: 'TC',
    Tv: 'TV',
    Uk: 'UK',
    Ug: 'UG',
    Ua: 'UA',
    Ae: 'AE',
    Us: 'US',
    Um: 'UM',
    Uy: 'UY',
    Uz: 'UZ',
    Vu: 'VU',
    Va: 'VA',
    Ve: 'VE',
    Vn: 'VN',
    Vg: 'VG',
    Vi: 'VI',
    Wf: 'WF',
    Eh: 'EH',
    Ye: 'YE',
    Zr: 'ZR',
    Zm: 'ZM',
    Zw: 'ZW'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1DayTimePart = {
    NotSet: 'NOT_SET',
    Hour0To1: 'HOUR_0_TO_1',
    Hour1To2: 'HOUR_1_TO_2',
    Hour2To3: 'HOUR_2_TO_3',
    Hour3To4: 'HOUR_3_TO_4',
    Hour4To5: 'HOUR_4_TO_5',
    Hour5To6: 'HOUR_5_TO_6',
    Hour6To7: 'HOUR_6_TO_7',
    Hour7To8: 'HOUR_7_TO_8',
    Hour8To9: 'HOUR_8_TO_9',
    Hour9To10: 'HOUR_9_TO_10',
    Hour10To11: 'HOUR_10_TO_11',
    Hour11To12: 'HOUR_11_TO_12',
    Hour12To13: 'HOUR_12_TO_13',
    Hour13To14: 'HOUR_13_TO_14',
    Hour14To15: 'HOUR_14_TO_15',
    Hour15To16: 'HOUR_15_TO_16',
    Hour16To17: 'HOUR_16_TO_17',
    Hour17To18: 'HOUR_17_TO_18',
    Hour18To19: 'HOUR_18_TO_19',
    Hour19To20: 'HOUR_19_TO_20',
    Hour20To21: 'HOUR_20_TO_21',
    Hour21To22: 'HOUR_21_TO_22',
    Hour22To23: 'HOUR_22_TO_23',
    Hour23To24: 'HOUR_23_TO_24'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1Guest = {
    Unspecified: 'UNSPECIFIED',
    OneAdult: 'ONE_ADULT',
    TwoAdult: 'TWO_ADULT',
    OneAdultOneChild: 'ONE_ADULT_ONE_CHILD',
    TwoAdultOneChild: 'TWO_ADULT_ONE_CHILD',
    ThreeAdult: 'THREE_ADULT',
    FourAdult: 'FOUR_ADULT',
    TwoAdultTwoChild: 'TWO_ADULT_TWO_CHILD',
    ThreeAdultOneChild: 'THREE_ADULT_ONE_CHILD',
    OneAdultTwoChild: 'ONE_ADULT_TWO_CHILD',
    OneAdultThreeChild: 'ONE_ADULT_THREE_CHILD',
    OneAdultFourChild: 'ONE_ADULT_FOUR_CHILD',
    TwoAdultThreeChild: 'TWO_ADULT_THREE_CHILD',
    ThreeAdultTwoChild: 'THREE_ADULT_TWO_CHILD',
    FourAdultOneChild: 'FOUR_ADULT_ONE_CHILD',
    FiveAdult: 'FIVE_ADULT',
    SixAdult: 'SIX_ADULT',
    FourAdultTwoChild: 'FOUR_ADULT_TWO_CHILD'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1RateCodeType = {
    RateCodeTypeNotSet: 'RATE_CODE_TYPE_NOT_SET',
    Default: 'DEFAULT',
    Corporate: 'CORPORATE',
    Discount: 'DISCOUNT',
    Promotion: 'PROMOTION',
    External: 'EXTERNAL',
    BlockCode: 'BLOCK_CODE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1TaxType = {
    TaxUndefined: 'TAX_UNDEFINED',
    CityTax: 'CITY_TAX',
    TouristTax: 'TOURIST_TAX',
    Vat9Percent: 'VAT_9_PERCENT',
    Vat10Percent: 'VAT_10_PERCENT',
    Vat20Percent: 'VAT_20_PERCENT',
    DestinationFee: 'DESTINATION_FEE',
    StateTax: 'STATE_TAX',
    OccupancyTax: 'OCCUPANCY_TAX',
    CountyTax: 'COUNTY_TAX',
    LodgingTax: 'LODGING_TAX',
    Vat5Percent: 'VAT_5_PERCENT',
    Breakfast: 'BREAKFAST',
    EmployeeProtection: 'EMPLOYEE_PROTECTION',
    CityTaxAndOtherCombined: 'CITY_TAX_AND_OTHER_COMBINED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1UsaState = {
    UsaStateNotSet: 'USA_STATE_NOT_SET',
    Ak: 'AK',
    Al: 'AL',
    Ar: 'AR',
    As: 'AS',
    Az: 'AZ',
    Ca: 'CA',
    Co: 'CO',
    Ct: 'CT',
    Dc: 'DC',
    De: 'DE',
    Fl: 'FL',
    Fm: 'FM',
    Ga: 'GA',
    Gu: 'GU',
    Hi: 'HI',
    Ia: 'IA',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Ma: 'MA',
    Md: 'MD',
    Me: 'ME',
    Mh: 'MH',
    Mi: 'MI',
    Mn: 'MN',
    Mo: 'MO',
    Mp: 'MP',
    Ms: 'MS',
    Mt: 'MT',
    Nc: 'NC',
    Nd: 'ND',
    Ne: 'NE',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Nv: 'NV',
    Ny: 'NY',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pa: 'PA',
    Pr: 'PR',
    Pw: 'PW',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Va: 'VA',
    Vi: 'VI',
    Vt: 'VT',
    Wa: 'WA',
    Wi: 'WI',
    Wv: 'WV',
    Wy: 'WY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1YesNo = {
    YesNoNotSet: 'YES_NO_NOT_SET',
    No: 'NO',
    Yes: 'YES'
};
/**
 * AdyenApi - axios parameter creator
 * @export
 */
const AdyenApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Adyen submit additional details
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenAdditionalDetails: async (raw, options = {}) => {
            // verify required parameter 'raw' is not null or undefined
            (0, common_1.assertParamExists)('adyenAdditionalDetails', 'raw', raw);
            const localVarPath = `/payments/adyen/additional-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(raw, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Charge a booking via Adyen
         * @param {string} bookingId
         * @param {V1AdyenChargeBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenCharge: async (bookingId, body, options = {}) => {
            // verify required parameter 'bookingId' is not null or undefined
            (0, common_1.assertParamExists)('adyenCharge', 'bookingId', bookingId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('adyenCharge', 'body', body);
            const localVarPath = `/booking/{bookingId}/charge/adyen`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adyen submit additional details
         * @param {V1ConfirmRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenConfirm: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('adyenConfirm', 'body', body);
            const localVarPath = `/payments/adyen/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adyen new payment
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenNewPayment: async (raw, options = {}) => {
            // verify required parameter 'raw' is not null or undefined
            (0, common_1.assertParamExists)('adyenNewPayment', 'raw', raw);
            const localVarPath = `/payments/adyen/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(raw, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-Payment initialisation with Adyen
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenPrePayment: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('adyenPrePayment', 'body', body);
            const localVarPath = `/payments/adyen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adyen Webhook for handling notification events
         * @summary we have notifications setup in Adyen
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenWebhook: async (raw, options = {}) => {
            // verify required parameter 'raw' is not null or undefined
            (0, common_1.assertParamExists)('adyenWebhook', 'raw', raw);
            const localVarPath = `/payments/adyen/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(raw, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AdyenApiAxiosParamCreator = AdyenApiAxiosParamCreator;
/**
 * AdyenApi - functional programming interface
 * @export
 */
const AdyenApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdyenApiAxiosParamCreator)(configuration);
    return {
        /**
         * Adyen submit additional details
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adyenAdditionalDetails(raw, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adyenAdditionalDetails(raw, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Charge a booking via Adyen
         * @param {string} bookingId
         * @param {V1AdyenChargeBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adyenCharge(bookingId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adyenCharge(bookingId, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Adyen submit additional details
         * @param {V1ConfirmRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adyenConfirm(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adyenConfirm(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Adyen new payment
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adyenNewPayment(raw, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adyenNewPayment(raw, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Pre-Payment initialisation with Adyen
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adyenPrePayment(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adyenPrePayment(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Adyen Webhook for handling notification events
         * @summary we have notifications setup in Adyen
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adyenWebhook(raw, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adyenWebhook(raw, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AdyenApiFp = AdyenApiFp;
/**
 * AdyenApi - factory interface
 * @export
 */
const AdyenApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdyenApiFp)(configuration);
    return {
        /**
         * Adyen submit additional details
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenAdditionalDetails(raw, options) {
            return localVarFp.adyenAdditionalDetails(raw, options).then((request) => request(axios, basePath));
        },
        /**
         * Charge a booking via Adyen
         * @param {string} bookingId
         * @param {V1AdyenChargeBody} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenCharge(bookingId, body, options) {
            return localVarFp.adyenCharge(bookingId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Adyen submit additional details
         * @param {V1ConfirmRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenConfirm(body, options) {
            return localVarFp.adyenConfirm(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Adyen new payment
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenNewPayment(raw, options) {
            return localVarFp.adyenNewPayment(raw, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-Payment initialisation with Adyen
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenPrePayment(body, options) {
            return localVarFp.adyenPrePayment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Adyen Webhook for handling notification events
         * @summary we have notifications setup in Adyen
         * @param {string} raw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adyenWebhook(raw, options) {
            return localVarFp.adyenWebhook(raw, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdyenApiFactory = AdyenApiFactory;
/**
 * AdyenApi - object-oriented interface
 * @export
 * @class AdyenApi
 * @extends {BaseAPI}
 */
class AdyenApi extends base_1.BaseAPI {
    /**
     * Adyen submit additional details
     * @param {string} raw
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenApi
     */
    adyenAdditionalDetails(raw, options) {
        return (0, exports.AdyenApiFp)(this.configuration).adyenAdditionalDetails(raw, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Charge a booking via Adyen
     * @param {string} bookingId
     * @param {V1AdyenChargeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenApi
     */
    adyenCharge(bookingId, body, options) {
        return (0, exports.AdyenApiFp)(this.configuration).adyenCharge(bookingId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adyen submit additional details
     * @param {V1ConfirmRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenApi
     */
    adyenConfirm(body, options) {
        return (0, exports.AdyenApiFp)(this.configuration).adyenConfirm(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adyen new payment
     * @param {string} raw
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenApi
     */
    adyenNewPayment(raw, options) {
        return (0, exports.AdyenApiFp)(this.configuration).adyenNewPayment(raw, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Pre-Payment initialisation with Adyen
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenApi
     */
    adyenPrePayment(body, options) {
        return (0, exports.AdyenApiFp)(this.configuration).adyenPrePayment(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Adyen Webhook for handling notification events
     * @summary we have notifications setup in Adyen
     * @param {string} raw
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenApi
     */
    adyenWebhook(raw, options) {
        return (0, exports.AdyenApiFp)(this.configuration).adyenWebhook(raw, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdyenApi = AdyenApi;
/**
 * BookingServiceApi - axios parameter creator
 * @export
 */
const BookingServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * This method is used to check availability of rooms. Client can use AvailabilityOptions to filter the response
         * @param {V1AvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceAvailability: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingServiceAvailability', 'body', body);
            const localVarPath = `/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method returns the booking summary given the booking id
         * @summary Get booking summary by id
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceBookingSummary: async (bookingId, options = {}) => {
            // verify required parameter 'bookingId' is not null or undefined
            (0, common_1.assertParamExists)('bookingServiceBookingSummary', 'bookingId', bookingId);
            const localVarPath = `/booking/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to return the calendar view of room(s)
         * @param {V1CalendarRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceCalendar: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingServiceCalendar', 'body', body);
            const localVarPath = `/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to create the booking entry (not reserved yet)
         * @summary Create the booking entry
         * @param {V1CreateBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceCreateBooking: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('bookingServiceCreateBooking', 'body', body);
            const localVarPath = `/room/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method returns the booking status given the booking id
         * @param {string} bookingId
         * @param {string} hotelReferenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceGetBookingStatus: async (bookingId, hotelReferenceId, options = {}) => {
            // verify required parameter 'bookingId' is not null or undefined
            (0, common_1.assertParamExists)('bookingServiceGetBookingStatus', 'bookingId', bookingId);
            // verify required parameter 'hotelReferenceId' is not null or undefined
            (0, common_1.assertParamExists)('bookingServiceGetBookingStatus', 'hotelReferenceId', hotelReferenceId);
            const localVarPath = `/booking/status/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (hotelReferenceId !== undefined) {
                localVarQueryParameter['hotelReferenceId'] = hotelReferenceId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method returns the booking summary given the booking id
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServicePaymentProvider: async (bookingId, options = {}) => {
            // verify required parameter 'bookingId' is not null or undefined
            (0, common_1.assertParamExists)('bookingServicePaymentProvider', 'bookingId', bookingId);
            const localVarPath = `/payment/{bookingId}`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BookingServiceApiAxiosParamCreator = BookingServiceApiAxiosParamCreator;
/**
 * BookingServiceApi - functional programming interface
 * @export
 */
const BookingServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BookingServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * This method is used to check availability of rooms. Client can use AvailabilityOptions to filter the response
         * @param {V1AvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingServiceAvailability(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingServiceAvailability(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method returns the booking summary given the booking id
         * @summary Get booking summary by id
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingServiceBookingSummary(bookingId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingServiceBookingSummary(bookingId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method is used to return the calendar view of room(s)
         * @param {V1CalendarRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingServiceCalendar(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingServiceCalendar(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method is used to create the booking entry (not reserved yet)
         * @summary Create the booking entry
         * @param {V1CreateBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingServiceCreateBooking(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingServiceCreateBooking(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method returns the booking status given the booking id
         * @param {string} bookingId
         * @param {string} hotelReferenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingServiceGetBookingStatus(bookingId, hotelReferenceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingServiceGetBookingStatus(bookingId, hotelReferenceId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method returns the booking summary given the booking id
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookingServicePaymentProvider(bookingId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookingServicePaymentProvider(bookingId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.BookingServiceApiFp = BookingServiceApiFp;
/**
 * BookingServiceApi - factory interface
 * @export
 */
const BookingServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BookingServiceApiFp)(configuration);
    return {
        /**
         * This method is used to check availability of rooms. Client can use AvailabilityOptions to filter the response
         * @param {V1AvailabilityRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceAvailability(body, options) {
            return localVarFp.bookingServiceAvailability(body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method returns the booking summary given the booking id
         * @summary Get booking summary by id
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceBookingSummary(bookingId, options) {
            return localVarFp.bookingServiceBookingSummary(bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to return the calendar view of room(s)
         * @param {V1CalendarRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceCalendar(body, options) {
            return localVarFp.bookingServiceCalendar(body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to create the booking entry (not reserved yet)
         * @summary Create the booking entry
         * @param {V1CreateBookingRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceCreateBooking(body, options) {
            return localVarFp.bookingServiceCreateBooking(body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method returns the booking status given the booking id
         * @param {string} bookingId
         * @param {string} hotelReferenceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServiceGetBookingStatus(bookingId, hotelReferenceId, options) {
            return localVarFp.bookingServiceGetBookingStatus(bookingId, hotelReferenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * This method returns the booking summary given the booking id
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookingServicePaymentProvider(bookingId, options) {
            return localVarFp.bookingServicePaymentProvider(bookingId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BookingServiceApiFactory = BookingServiceApiFactory;
/**
 * BookingServiceApi - object-oriented interface
 * @export
 * @class BookingServiceApi
 * @extends {BaseAPI}
 */
class BookingServiceApi extends base_1.BaseAPI {
    /**
     * This method is used to check availability of rooms. Client can use AvailabilityOptions to filter the response
     * @param {V1AvailabilityRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServiceApi
     */
    bookingServiceAvailability(body, options) {
        return (0, exports.BookingServiceApiFp)(this.configuration).bookingServiceAvailability(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method returns the booking summary given the booking id
     * @summary Get booking summary by id
     * @param {string} bookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServiceApi
     */
    bookingServiceBookingSummary(bookingId, options) {
        return (0, exports.BookingServiceApiFp)(this.configuration).bookingServiceBookingSummary(bookingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is used to return the calendar view of room(s)
     * @param {V1CalendarRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServiceApi
     */
    bookingServiceCalendar(body, options) {
        return (0, exports.BookingServiceApiFp)(this.configuration).bookingServiceCalendar(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is used to create the booking entry (not reserved yet)
     * @summary Create the booking entry
     * @param {V1CreateBookingRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServiceApi
     */
    bookingServiceCreateBooking(body, options) {
        return (0, exports.BookingServiceApiFp)(this.configuration).bookingServiceCreateBooking(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method returns the booking status given the booking id
     * @param {string} bookingId
     * @param {string} hotelReferenceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServiceApi
     */
    bookingServiceGetBookingStatus(bookingId, hotelReferenceId, options) {
        return (0, exports.BookingServiceApiFp)(this.configuration).bookingServiceGetBookingStatus(bookingId, hotelReferenceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method returns the booking summary given the booking id
     * @param {string} bookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingServiceApi
     */
    bookingServicePaymentProvider(bookingId, options) {
        return (0, exports.BookingServiceApiFp)(this.configuration).bookingServicePaymentProvider(bookingId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BookingServiceApi = BookingServiceApi;
/**
 * OperaLiveSupportApi - axios parameter creator
 * @export
 */
const OperaLiveSupportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Resending confirmation email from internal dashboard
         * @param {V1ResendConfirmationEmailRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operaLiveSupportResendConfirmationEmailFromDashboard: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('operaLiveSupportResendConfirmationEmailFromDashboard', 'body', body);
            const localVarPath = `/livesupport/opera/resend-confirmation-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OperaLiveSupportApiAxiosParamCreator = OperaLiveSupportApiAxiosParamCreator;
/**
 * OperaLiveSupportApi - functional programming interface
 * @export
 */
const OperaLiveSupportApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.OperaLiveSupportApiAxiosParamCreator)(configuration);
    return {
        /**
         * Resending confirmation email from internal dashboard
         * @param {V1ResendConfirmationEmailRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async operaLiveSupportResendConfirmationEmailFromDashboard(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.operaLiveSupportResendConfirmationEmailFromDashboard(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.OperaLiveSupportApiFp = OperaLiveSupportApiFp;
/**
 * OperaLiveSupportApi - factory interface
 * @export
 */
const OperaLiveSupportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.OperaLiveSupportApiFp)(configuration);
    return {
        /**
         * Resending confirmation email from internal dashboard
         * @param {V1ResendConfirmationEmailRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        operaLiveSupportResendConfirmationEmailFromDashboard(body, options) {
            return localVarFp.operaLiveSupportResendConfirmationEmailFromDashboard(body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OperaLiveSupportApiFactory = OperaLiveSupportApiFactory;
/**
 * OperaLiveSupportApi - object-oriented interface
 * @export
 * @class OperaLiveSupportApi
 * @extends {BaseAPI}
 */
class OperaLiveSupportApi extends base_1.BaseAPI {
    /**
     * Resending confirmation email from internal dashboard
     * @param {V1ResendConfirmationEmailRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperaLiveSupportApi
     */
    operaLiveSupportResendConfirmationEmailFromDashboard(body, options) {
        return (0, exports.OperaLiveSupportApiFp)(this.configuration).operaLiveSupportResendConfirmationEmailFromDashboard(body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OperaLiveSupportApi = OperaLiveSupportApi;
